import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  recordSuccessMeasureResponse,
  getSuccessMeasureResponseRequestStatus,
  loadSuccessMeasureResponsesByLessonId,
  getSuccessMeasureResponsesByLessonId,
  STATUS,
} from 'edrolo/domains/lessons';

export const useSuccessMeasureResponses = (successMeasureId, lessonId) => {
  const dispatch = useDispatch();

  const recordRequest = useSelector((state) => {
    return getSuccessMeasureResponseRequestStatus(state, successMeasureId);
  });

  const successMeasureResponses = useSelector((state) => {
    return getSuccessMeasureResponsesByLessonId(state, lessonId);
  });

  useEffect(() => {
    if (!recordRequest) {
      dispatch(loadSuccessMeasureResponsesByLessonId.signal(lessonId));
    }
  }, [dispatch, lessonId, recordRequest]);

  const save = (
    lessonId,
    profileId,
    successMeasureId,
    value,
    successNavigateUrl
  ) =>
    dispatch(
      recordSuccessMeasureResponse.signal(
        lessonId,
        profileId,
        successMeasureId,
        value,
        successNavigateUrl
      )
    );

  return {
    data: successMeasureResponses,
    loading: [STATUS.LOADING, STATUS.SUBMITTING].includes(recordRequest),
    save,
  };
};
